import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

export const useFtux = (): boolean => {
  const {search} = useLocation();

  const ftux = useMemo(() => {
    return !!new URLSearchParams(search).get('new');
  }, []);

  return ftux;
};

export default useFtux;
